import { render, staticRenderFns } from "./Establecimiento.vue?vue&type=template&id=5788ece6"
import script from "./Establecimiento.vue?vue&type=script&lang=js"
export * from "./Establecimiento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports